<template>
  <v-row>
    <v-col cols="12">
      <v-row align="center">
        <v-col>
          <v-switch v-model="accessModel.canModerate" label="Контингент" />
        </v-col>
        <v-col v-if="isAvailableModule('pass')">
          <v-switch v-model="accessModel.canGivePass" label="Пропуска" />
        </v-col>
        <v-col v-if="isAvailableModule('rating')">
          <v-switch
            v-model="accessModel.canModerateRating"
            label="Рейтинг (факультет)"
          />
        </v-col>
        <v-col v-if="isAvailableModule('rating')">
          <v-switch
            v-model="accessModel.canCommissionRating"
            label="Рейтинг (комиссия)"
          />
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">
      <v-combobox
        multiple
        clearable
        v-model="accessModel.selected"
        :items="categoryList"
        item-text="name"
        item-value="id"
        :disabled="!accessModel.canModerate && !accessModel.canGivePass"
        label="Выбор категорий модерации"
      />
    </v-col>
  </v-row>
</template>

<script>
import { isAvailableModule } from "@/services/systemConfig.service";
export default {
  name: "ModerateForm",

  model: {
    prop: "access",
    event: "update"
  },

  props: {
    categoryList: { type: Array, default: () => [] },
    userManagement: { type: Array, default: () => [] },
    access: {
      type: Object,
      required: true,
      default: () => (
        { canModerate: false, selected: [] },
        { canGivePass: false, selected: [] },
        { canModerateRating: false, selected: [] },
        { canCommissionRating: false, selected: [] }
      )
    }
  },

  watch: {
    "access.canModerate": {
      handler(newValue) {
        if (!newValue && !this.access.canGivePass) {
          this.selected = [];
        }
      }
    },

    "access.canModerateRating": {
      handler(newValue) {
        if (!newValue && !this.access.canModerateRating) {
          this.selected = [];
        }
      }
    },

    "access.canCommissionRating": {
      handler(newValue) {
        if (!newValue && !this.access.canCommissionRating) {
          this.selected = [];
        }
      }
    },

    "access.canGivePass": {
      handler(newValue) {
        if (!newValue && !this.access.canModerate) {
          this.selected = [];
        }
      }
    }
  },

  methods: {
    isAvailableModule
  },

  computed: {
    accessModel: {
      get() {
        return this.access;
      },

      set(newValue) {
        this.$emit("update", newValue);
      }
    }
  }
};
</script>
